export class BasementWindowRulesService {
    private heightLimit: number;
    private widthLimit: number;

    constructor() {
        this.heightLimit = 580;
        this.widthLimit = 580;
    }

    areConditionsMet(width, height) {
        return this.isHeightBelowLimit(height) || this.isWidthBelowLimit(width);
    }

    isHeightBelowLimit(height) {
        return this.heightLimit > height;
    }

    isWidthBelowLimit(width) {
        return this.widthLimit > width;
    }
}
